import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MediaListComponent } from 'src/app/view/media-list/media-list.component';
import { RouterModule } from '@angular/router';
import { MediaRoutingModule } from './media-routing.module';
import { SharedModule } from '../shared/shared.module';



@NgModule({
  declarations: [
    MediaListComponent
  ],
  imports: [
    CommonModule,
    RouterModule,
    MediaRoutingModule,
    SharedModule
  ]
})
export class MediaModule { }
